import { isCurrencyISO } from '@/constants/currencies';
import { isNil } from 'lodash/fp';

export const getReportingCurrencyISO = (currencyInfo: unknown) => {
  if (typeof currencyInfo !== 'object') return null;
  if (isNil(currencyInfo)) return null;

  if (
    'reporting_currency_iso' in currencyInfo &&
    isCurrencyISO(currencyInfo.reporting_currency_iso)
  ) {
    return currencyInfo['reporting_currency_iso'];
  }

  return null;
};
